import { componentsToColor } from "pdf-lib";

const initialState = {
  records: [],
  totalRecords: 0,
  incomeLogs: [],
}
export const incomeAnalyzer = (state = initialState, action) => {
  switch (action.type) {
    case "INCOME_ANALYZER": {
      console.log('action.data', action.data)
      return { ...state, records: action.data?.docs, totalRecords: action?.data?.totalDocs !== undefined ? action?.data?.totalDocs : 0 };
    }
    case "MERGE_INCOME_ANALYZER": {
      console.log('action.data', action.data)
      return { ...state, records: [...state.records, ...action.data?.docs], totalRecords: action?.data?.totalDocs !== undefined ? action?.data?.totalDocs : 0 };
    }
    case "RESET_INCOME_ANALYZER": {
      console.log('action.data', action.data)
      return { ...state, records: [], totalRecords: 0 };
    }
    case "INCOME_LOGS_LISTING": {
      return { ...state, incomeLogs: action.data }
    }
    case "RESET_INCOME_LOGS_LISTING": {
      return {...state, incomeLogs: []}
    }
    case "REMOVE_INCOME_ANALYZER_ITEM": {
      const { activeMainIndex, activeIndex, activeSubIndex } = action.data;
      console.log(action.data)
      const updatedIncomeAnalyzer = { ...state };

      console.log("asdasdwe", activeMainIndex, activeIndex, activeSubIndex)

      // Remove the activeSubIndex document
      updatedIncomeAnalyzer.records[activeMainIndex].taxpayer_name[activeIndex].docs.splice(activeSubIndex, 1);

      // Check if there are no docs left for the current taxpayer_name
      if (updatedIncomeAnalyzer.records[activeMainIndex].taxpayer_name[activeIndex].docs.length === 0) {
        updatedIncomeAnalyzer.records[activeMainIndex].taxpayer_name.splice(activeIndex, 1);
      }

      // If no taxpayer_name left, remove the main index
      if (updatedIncomeAnalyzer.records[activeMainIndex].taxpayer_name.length === 0) {
        updatedIncomeAnalyzer.records.splice(activeMainIndex, 1);
      }

      // Optionally return the updated total records
      return { 
        ...updatedIncomeAnalyzer,
        totalRecords: updatedIncomeAnalyzer.records.reduce((total, mainIndex) => total + mainIndex.taxpayer_name.length, 0)
      };
    }

    case "LOGOUT":
      return initialState;
    default:
      return state;

  }
};
